/* eslint-disable @typescript-eslint/consistent-type-assertions */
import {
  ThemeType,
  EContentTypes,
  EFontTypes,
  IFontSizeResponsive,
} from 'theme'
import { DESKTOP, MOBILE, TABLET } from 'utils/styles'

import { FONT_SIZES } from './fontSizes'

// There is any since some ThemeTypes are using .background and some .background(opacit:number)=> void and that causes a type error
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const typography = (projectTheme: any): IFontSizeResponsive => {
  const PT = projectTheme as ThemeType

  const listOfTypes = Object.values(EFontTypes)
  const listOfContents = Object.values(EContentTypes)

  const generateContent = (size: EFontTypes, contentType: EContentTypes) => ({
    [`@media ${DESKTOP}`]: {
      ...FONT_SIZES(PT)[size][contentType].desktop,
    },
    [`@media ${TABLET}`]: {
      ...FONT_SIZES(PT)[size][contentType].tablet,
    },
    [`@media ${MOBILE}`]: {
      ...FONT_SIZES(PT)[size][contentType].phone,
    },
  })

  const generateSize = () => {
    const size = {} as IFontSizeResponsive
    listOfTypes.forEach((type) => {
      size[type] = {} as IFontSizeResponsive[EFontTypes]
      listOfContents.forEach((content) => {
        size[type][content] = generateContent(type, content)
      })
      return size
    })
    return size
  }

  return generateSize()
}
